'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("currencyService", function ($http) {
  var currencies = [];
  var currenciesMap = {};
  var getFlagCode = function getFlagCode(isoCode) {
    return isoCode.substr(0, 2).toLowerCase();
  };
  return {
    $load: function $load() {
      return $http.get("/rest/devises").then(function (response) {
        currencies = response.data;
        _.each(currencies, function (currency) {
          currency.flagCode = getFlagCode(currency.isoCode);
          currenciesMap[currency.name] = currency;
        });
      });
    },
    getAll: function getAll() {
      return angular.copy(currencies);
    },
    getByName: function getByName(name) {
      var result = _.find(currencies, function (currency) {
        return currency.name === name;
      });
      return angular.copy(result);
    },
    getByNames: function getByNames(names) {
      var results = _.filter(currencies, function (currency) {
        return _.includes(names, currency.name);
      });
      return angular.copy(results);
    },
    getCurrencySign: function getCurrencySign(currency) {
      if (currency == null) {
        return null;
      }
      return currenciesMap[currency] ? currenciesMap[currency].sign : currency;
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/currencyService.js
// module id = 2869
// module chunks = 13